import { Directive, ElementRef } from '@angular/core';

@Directive({
    selector: '[appPassword]'
})
export class AppPasswordDirective {

    private _shown = false;

    constructor(private el: ElementRef) {
        this.setup();
    }

    toggle(span: HTMLElement) {

        this._shown = !this._shown;

        if (this._shown) {

            this.el.nativeElement.setAttribute('type', 'text');
            span.innerHTML = "<i class='far fa-eye-slash'></i>";

        } else {

            this.el.nativeElement.setAttribute('type', 'password');
            span.innerHTML = "<i class='far fa-eye'></i>";

        }
    }

    setup() {

        const span = document.createElement('span');
        span.className = "input-group-addon";
        span.innerHTML = "<i class='far fa-eye'></i>";

        span.addEventListener('click', (event) => {
            this.toggle(span);
        });

        this.el.nativeElement.before(span);
    }
}


// WEBPACK FOOTER //
// ./ClientApp/app/app-password.directive.ts